module.exports = __webpack_public_path__ + "img/hx_2.effb9d6d.jpg";